import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  iconColumnHeaderSelectButton: {
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        top: pxToRem(14),
        left: pxToRem(7),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
      '& .ms-DetailsHeader-cellName .ms-Icon': {
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
        paddingLeft: pxToRem(1),
      },
    },
  },
  selectButton: {
    height: pxToRem(34),
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  actionButtons: {
    textAlign: 'right',
  },
  viewButton: {
    marginLeft: pxToRem(40),
    fontSize: pxToRem(14),
  },
  bold: {
    fontWeight: 600,
  },
  listActions: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        width: pxToRem(50),
        height: pxToRem(20),
        fontSize: pxToRem(14),
        textAlign: 'center',
        lineHeight: pxToRem(20),
        fontWeight: 400,
      },
    },
  },
  allocation: {
    width: pxToRem(64),
    height: `${pxToRem(24)} !important`,
    paddingTop: pxToRem(4),
    selectors: {
      '& .ms-TextField-field': {
        fontSize: `${pxToRem(12)} !important`,
        background: theme.palette.neutralLight,
      },
    },
  },
  allocationText: {
    paddingTop: pxToRem(8),
    paddingLeft: pxToRem(42),
    fontSize: pxToRem(14),
    fontWeight: 600,
    marginRight: pxToRem(618),
    color: theme.palette.neutralDark,
  },
  allocationBox: {
    width: pxToRem(64),
    height: `${pxToRem(24)} !important`,
    selectors: {
      '& .ms-TextField-field': {
        fontSize: `${pxToRem(12)} !important`,
      },
    },
  },

  allocationCell: {
    selectors: {
      '& .ms-DetailsRow-cell': {
        paddingTop: `${pxToRem(4)} !important`,
        paddingBottom: `${pxToRem(4)} !important`,
      },
      '& .ms-DetailsRow-cell[data-automation-key="allocation"]': {
        paddingTop: `${pxToRem(4)} !important`,
        paddingBottom: `${pxToRem(8)} !important`,
      },
      '& .ms-TextField-fieldGroup': {
        height: pxToRem(24),
        marginBottom: pxToRem(4),
      },
    },
  },
  footer: {
    width: '100%',
    height: `${pxToRem(12)} !important`,
    minHeight: pxToRem(32),
  },
  footerRow: {
    display: 'flex',
    selectors: {
      '& .ms-TextField-fieldGroup': {
        height: `${pxToRem(24)} !important`,
      },
    },
  },
  allocationErrorMessage: {
    color: theme.palette.accentError,
    fontSize: pxToRem(12),
    float: 'right',
    marginRight: pxToRem(150),
  },
  errorMessageAlignment: {
    marginRight: pxToRem(170),
  },
  productDropDown: {
    marginRight: pxToRem(10),
    width: pxToRem(190),
    height: pxToRem(32),
    selectors: {
      '& .dropdown': {
        '& .ms-Dropdown-title, & .ms-Dropdown-caretDownWrapper': {
          height: pxToRem(25),
          lineHeight: pxToRem(23),
        },
      },
    },
  },
  bundleActivity: {
    backgroundColor: 'transparent',
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
    width: '100%',
    zIndex: 10,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '0',
    selectors: {
      '& .ms-CommandBar': {
        backgroundColor: 'transparent',
        paddingRight: '0',
      },
      '& .ms-Button': {
        backgroundColor: 'transparent',
      },
      '& .ms-Button .ms-Icon': {
        marginRight: pxToRem(10),
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
      },
      '& .ms-Button:hover .ms-Icon': {
        backgroundColor: 'transparent',
        background: 'none',
      },
      '& .ms-Button:active .ms-Icon': {
        backgroundColor: 'transparent',
        background: 'none',
      },
      '& .ms-Button:active:after .ms-Icon': {
        backgroundColor: 'transparent',
        background: 'none',
      },
    },
  },
});
